import React from 'react';
import styled from 'styled-components';

import { Colors } from 'constants/ui';
import { formatLastSeen, isRecentlyOnline } from 'utils/formatters';

type Props = {
  online?: boolean;
  lastSeenAt?: string | null;
  showLabel?: boolean;
};

const DOT_SIZE_PX = 8;

export const PresenceDot: React.FC<Props> = ({
  online,
  lastSeenAt,
  showLabel = true,
}) => {
  const isLive =
    online === true ||
    (online === undefined && isRecentlyOnline(lastSeenAt));
  const label = isLive ? 'online' : formatLastSeen(lastSeenAt);

  return (
    <Wrap>
      <Dot $live={isLive} />
      {showLabel ? <Label $live={isLive}>{label}</Label> : null}
    </Wrap>
  );
};

const Wrap = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
`;

const Dot = styled.span<{ $live: boolean }>`
  width: ${DOT_SIZE_PX}px;
  height: ${DOT_SIZE_PX}px;
  border-radius: 50%;
  background-color: ${({ $live }) =>
    $live ? Colors.successBright : Colors.borderStrong};
  box-shadow: ${({ $live }) =>
    $live ? `0 0 0 2px ${Colors.successBgSoft}` : 'none'};
`;

const Label = styled.span<{ $live: boolean }>`
  font-size: 12px;
  color: ${({ $live }) => ($live ? Colors.successDark : Colors.slateGrey)};
  font-weight: 600;
`;
